import img404 from '@assets/errors/404.png';
import img500 from '@assets/errors/500.png';
import imgTimeout from '@assets/errors/502-504.png';
import imgUnknown from '@assets/errors/unknown.svg';

import {DEFAULT_ERROR_TITLE, ErrorKind, SystemErrorVariant} from './types';

export type ErrorContent = {
    imageSrc: string;
    title: string;
    description: string;
    variant: SystemErrorVariant;
};

export const ERROR_CONTENT: Record<ErrorKind, ErrorContent> = {
    'not-found': {
        imageSrc: img404,
        title: 'Такой страницы больше нет',
        description: 'Возможно, адрес страницы изменился или она была удалена',
        variant: 'back'
    },
    internal: {
        imageSrc: img500,
        title: DEFAULT_ERROR_TITLE,
        description: 'Произошла внутренняя ошибка. Мы уже работаем над её исправлением',
        variant: 'reload'
    },
    timeout: {
        imageSrc: imgTimeout,
        title: 'Слишком долгое ожидание',
        description: 'Сервер не отвечает. Возможно, он временно недоступен',
        variant: 'reload'
    },
    unknown: {
        imageSrc: imgUnknown,
        title: DEFAULT_ERROR_TITLE,
        description:
            'Мы уже разбираемся с этим. Если перезагрузка страницы не помогла — обратитесь, пожалуйста, к нашим менеджерам',
        variant: 'reload'
    }
};

export function getErrorKind(code?: number | string | null): ErrorKind {
    const normalized = String(code ?? '').toLowerCase();

    if (normalized === '404') {
        return 'not-found';
    }

    if (normalized === '500') {
        return 'internal';
    }

    if (normalized === '502' || normalized === '503' || normalized === '504') {
        return 'timeout';
    }

    return 'unknown';
}
